module.exports = __webpack_public_path__ + "img/Lsg_Speicher.b119cecd.jpg";